import type { CSSProperties } from "react";
import Image from "next/image";

/** Responsive srcsets resolved on the server (see `testimonialImageSources`). */
export type TestimonialPictureSources = {
  avif?: string;
  webp?: string;
};

type CcTestimonialPictureProps = {
  src: string;
  alt: string;
  sizes: string;
  sources?: TestimonialPictureSources;
  style?: CSSProperties;
  crop?: string;
};

/**
 * Serves the optimizer's AVIF/WebP variants straight from the CDN instead of
 * `/_next/image`. The srcsets arrive as props so the client bundle never
 * includes the image manifest.
 */
export function CcTestimonialPicture({ src, alt, sizes, sources, style, crop }: CcTestimonialPictureProps) {
  const picture = (
    <picture>
      {sources?.avif ? <source type="image/avif" srcSet={sources.avif} sizes={sizes} /> : null}
      {sources?.webp ? <source type="image/webp" srcSet={sources.webp} sizes={sizes} /> : null}
      <Image src={src} alt={alt} fill sizes={sizes} style={style} unoptimized={Boolean(sources?.avif || sources?.webp)} />
    </picture>
  );

  // Keep the full source photo intact. The doubled image window frames the
  // left-hand person using ordinary CSS, including browsers without object-view-box.
  if (crop === "left-half") {
    return (
      <span data-testimonial-crop={crop} style={{ position: "absolute", inset: 0, overflow: "hidden" }}>
        <span style={{ position: "absolute", top: 0, left: 0, width: "200%", height: "100%" }}>{picture}</span>
      </span>
    );
  }
  return picture;
}
